import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { forEach } from 'lodash';
import { concat, Observable } from 'rxjs';
import { flatMap, take, tap } from 'rxjs/operators';
import { v4 } from 'uuid';
import { ActionsEnum as AppActionsEnum } from '../../store/app.actions';
import {
  ActionsEnum,
  IKeyValue,
  RemoveCookies,
  RemoveLocalStorageItem,
  SetCookie,
  setCookie,
  SetCookies,
  SetDeviceId,
  setDeviceId,
  SetLocalStorageItem,
} from './browser-manager-data.actions';
import { I2G_DEVICE_ID } from './browser-manager-data.service';
import { CookieService } from './cookie.service';
import { LocalStorageService } from './local-storage.service';

@Injectable()
export class BrowserManagerDataEffects {
  constructor(
    private _actions: Actions,
    private _localStorageService: LocalStorageService,
    private _cookieService: CookieService
  ) {}

  @Effect()
  initApp: Observable<SetCookie | SetDeviceId> = this._actions.pipe(
    ofType(AppActionsEnum.INIT_APP),
    take(1),
    flatMap(() => {
      let deviceId = this._cookieService.getCookie(I2G_DEVICE_ID);

      if (!deviceId) {
        deviceId = v4();
      }

      return concat([
        setCookie(I2G_DEVICE_ID, deviceId),
        setDeviceId(deviceId),
      ]);
    })
  );

  @Effect({ dispatch: false })
  setLocalStorageItem: Observable<any> = this._actions.pipe(
    ofType(ActionsEnum.SET_LOCAL_STORAGE_ITEM),
    tap(({ payload }: SetLocalStorageItem) =>
      this._localStorageService.setItem(payload.key, payload.value)
    )
  );

  @Effect({ dispatch: false })
  removeLocalStorageItem: Observable<any> = this._actions.pipe(
    ofType(ActionsEnum.REMOVE_LOCAL_STORAGE_ITEM),
    tap(({ payload }: RemoveLocalStorageItem) =>
      this._localStorageService.removeItem(payload.key)
    )
  );

  @Effect({ dispatch: false })
  setCookie: Observable<any> = this._actions.pipe(
    ofType(ActionsEnum.SET_COOKIE),
    tap(({ payload }: SetCookie) =>
      this._cookieService.setCookie(payload.key, payload.value)
    )
  );

  @Effect({ dispatch: false })
  setCookies: Observable<any> = this._actions.pipe(
    ofType(ActionsEnum.SET_COOKIES),
    tap(({ payload }: SetCookies) => {
      const { cookies } = payload;

      forEach(cookies, (cookie: IKeyValue) =>
        this._cookieService.setCookie(cookie.key, cookie.value)
      );
    })
  );

  @Effect({ dispatch: false })
  removeCookies: Observable<any> = this._actions.pipe(
    ofType(ActionsEnum.REMOVE_COOKIES),
    tap(({ payload }: RemoveCookies) =>
      payload.keys.forEach((key: string) =>
        this._cookieService.removeCookie(key)
      )
    )
  );
}
